import Career from "./components/Body/Career";
import Personal from "./components/Body/Personal";
import Header from "./components/Header";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Career />
      <Personal />
    </div>
  );
}

export default App;
